const sign = require('jwt-encode');

export const generateJWSToken = (topic) => {
  return sign({
    "mercure": {
      "publish": [
        "*"
      ],
      "subscribe": Array.isArray(topic) ? topic : [topic]
    }
  }, process.env.REACT_APP_MERCURE_SUBSCRIBER_JWT, "HS256");
};